import { createContext, use } from 'react';

import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export type SnackbarMessage = {
  message: string;
  severity?: 'success' | 'error' | 'warning' | 'info';
  autoHideDuration?: number;
};

export type SnackbarContext = {
  addSnackbar: (snackbar: SnackbarMessage) => void;
  addErrorSnackbar: (error: FetchBaseQueryError | SerializedError) => void;
};

export const SnackbarContext = createContext<SnackbarContext>({
  addSnackbar: () => null,
  addErrorSnackbar: () => null,
});

export const useSnackbar = () => use(SnackbarContext);
